/**
 * Formats an E.164 phone number for display. NANP numbers (+1) become
 * "+1 (416) 555-0123"; anything else is returned unchanged.
 */
export function formatPhone(e164: string): string {
  const nanp = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164);
  if (nanp) return `+1 (${nanp[1]}) ${nanp[2]}-${nanp[3]}`;
  return e164;
}
